// /opt/isp_erp/frontend/src/pages/warehouse/sucursalesTema.js
import { createTheme } from "@mui/material/styles";

export const temaSucursales = createTheme({
  palette: {
    primary: { main: "#2563eb", dark: "#1d4ed8", light: "#60a5fa" },
    secondary: { main: "#7c3aed" },
    success: { main: "#16a34a" },
    warning: { main: "#d97706" },
    error: { main: "#dc2626" },
    text: { primary: "#0f172a", secondary: "#64748b" },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: "inherit", button: { textTransform: "none", fontWeight: 600 } },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 10, paddingInline: 16 } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 16 } } },
    MuiDialogTitle: { styleOverrides: { root: { fontWeight: 700, padding: "18px 24px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" } } },
    MuiDialogContent: { styleOverrides: { root: { paddingTop: 20 } } },
    MuiDialogActions: { styleOverrides: { root: { padding: "14px 24px", borderTop: "1px solid #e2e8f0", background: "#fafbfc" } } },
    MuiTableCell: {
      styleOverrides: {
        head: { backgroundColor: "#f1f5f9", color: "#475569", fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em", borderBottom: "1px solid #e2e8f0" },
        root: { borderBottom: "1px solid #eef2f7" },
      },
    },
    MuiTableRow: { styleOverrides: { root: { "&.MuiTableRow-hover:hover": { backgroundColor: "#f8fafc" } } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiTab: { styleOverrides: { root: { textTransform: "none", fontWeight: 600, minHeight: 54 } } },
    MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: 3 } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 10, backgroundColor: "#fff" } } },
  },
});
